import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useAds, useImpression, trackAd } from "@/lib/ads";

export function AdSlot() {
  const { t } = useI18n();
  const { data } = useAds();
  const slot = data?.ad_slot;
  const hasCreative = !!(slot?.image_url && slot?.target_url);
  const ref = useImpression(data && slot ? "ad_slot" : null);
  if (!data || !slot) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div ref={ref} data-testid="ad-slot" className="relative">
        <span className="absolute -top-4 end-0 font-mono text-[10px] uppercase tracking-widest text-slate-400">
          {t("ad.label")}{slot.advertiser ? ` · ${slot.advertiser}` : ""}
        </span>
        {hasCreative ? (
          <a data-testid="ad-slot-creative" href={slot.target_url} target="_blank" rel="sponsored noopener noreferrer" onClick={() => trackAd("ad_slot", "click")} className="block rounded-xl overflow-hidden border border-slate-200 bg-white hover:shadow-md transition-shadow">
            <img src={slot.image_url} alt={slot.alt_text || slot.advertiser || t("ad.label")} className="w-full max-h-[250px] object-cover" loading="lazy" />
          </a>
        ) : (
          <div style={{ backgroundColor: "#ffffff" }} className="rounded-xl border border-dashed border-slate-300 px-6 py-8 sm:py-10 text-center shadow-sm">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-x-4 gap-y-1">
              <span style={{ color: "#000000" }} className="font-display font-extrabold text-2xl sm:text-3xl tracking-tight">Advertise Here</span>
              <span style={{ color: "#d1d5db" }} className="hidden sm:inline text-2xl">|</span>
              <span dir="rtl" style={{ color: "#000000" }} className="font-display font-extrabold text-2xl sm:text-3xl tracking-tight">أعلن هنا</span>
            </div>
            <div className="mt-4 flex flex-col items-center gap-1.5">
              <Link data-testid="ad-advertise-link" to="/advertise" onClick={() => trackAd("ad_slot", "click")} className="inline-flex items-center px-4 py-1.5 rounded-full bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700 transition-colors">{t("advertise.viewKit")}</Link>
              <a data-testid="ad-contact-link" href="mailto:info@trustedtechno.com" style={{ color: "#000000" }} className="text-sm font-semibold underline decoration-2 underline-offset-4 hover:text-violet-700 transition-colors">info@trustedtechno.com</a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
